import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

export const allowedScenarios = [
  SCENARIO_STEP.PRODUCT_ISSUED,
  SCENARIO_STEP.GO_TO_LEADGEN,
  SCENARIO_STEP.CREDIT_OFFERS_LOADING,
  SCENARIO_STEP.CREDIT_SELECTION,
  SCENARIO_STEP.BANKS_REFUSED,
  SCENARIO_STEP.OFFER_DISBURSEMENT,
  SCENARIO_STEP.CONDITIONS_SELECTION,
] as const;
